export default "__VITE_ASSET__1183ce06__"